import { isUUID } from 'utils/uuid';
import CommandOperation from './command_operations';

export function handleUpdateCommand(commands, dataRow, dataRowIdField) {
	const dataRowId = dataRow[dataRowIdField];
	const createCommandExists = commandExists(commands, CommandOperation.CREATE, dataRowId);

	if(createCommandExists) {
		const updatedCommands = deleteCommandByOperation(commands, CommandOperation.CREATE, dataRowId);
		return handleCreateCommand(updatedCommands, dataRow);
	} else {
		const updateCommandExists = commandExists(commands, CommandOperation.UPDATE, dataRowId);
		const updatedCommands =  updateCommandExists ? deleteCommandByOperation(commands, CommandOperation.UPDATE, dataRowId) : commands;

		return addUpdateCommand(updatedCommands, dataRow, dataRowIdField);
	}
}

export function handleCreateCommand(commands, dataRow) {
	const createCommand = { "add": { "values": Object.assign({}, dataRow) } };
	return { commands: [...commands, createCommand] };
}

const addUpdateCommand = (commands, dataRow, dataRowIdField) => {
	const dataRowId = dataRow[dataRowIdField];
	const updateCommand = { "update": { "values": Object.assign({}, dataRow, { "id": dataRowId }) } };

	return { commands: [...commands, updateCommand] };
};

export function handleRemoveCommand(commands, dataRowId) {
	const createCommandExists = commandExists(commands, CommandOperation.CREATE, dataRowId);
	const updateCommandExists = commandExists(commands, CommandOperation.UPDATE, dataRowId);

	if (updateCommandExists && isClientSideId(dataRowId)) {
		return deleteCommandByOperation(commands, CommandOperation.UPDATE, dataRowId);
	} else if (updateCommandExists && !isClientSideId(dataRowId)) {
		const updatedCommands = deleteCommandByOperation(commands, CommandOperation.UPDATE, dataRowId);
		return addRemoveCommand(updatedCommands, dataRowId);
	} else if (createCommandExists) {
		return deleteCommandByOperation(commands, CommandOperation.CREATE, dataRowId);
	} else {
		return addRemoveCommand(commands, dataRowId);
	}
}

const commandExists = (commands, commandOperation, dataRowId) => {
	var commandExistFlag = false;
	for (let cont = 0; cont < commands.length; cont++) {
		let command = commands[cont];
		let commandType = command[commandOperation];

		if (commandType) {
			let commandValues = commandType['values'];
			let commandId = commandValues.id;

			if (commandValues && commandId) {
				if (commandId === dataRowId) {
					commandExistFlag = true;
					break;
				}
			}
		}
	}

	return commandExistFlag;
};

const isClientSideId = (dataRowId) => {
	return isUUID(dataRowId);
};

const deleteCommandByOperation = (commands, commandOperation, dataRowId) => {
	const otherCommands = commands.filter(command => !command.hasOwnProperty(commandOperation));
	return otherCommands.concat(buildCommandsWithoutDeletedCommand(commands, commandOperation, dataRowId));
};

const buildCommandsWithoutDeletedCommand = (commands, commandOperation, commandToRemoveId) => {
	return commands
	.filter(command => !!command[commandOperation])
	.filter(command => command[commandOperation].values.id !== commandToRemoveId);
};

const addRemoveCommand = (commands, dataRowId) => {
	const initializedCommands = initializeRemoveCommands(commands);
	return buildRemoveCommands(initializedCommands, dataRowId);
};

const initializeRemoveCommands = (commands) => {
	const removeCommand = commands.find(command => command.hasOwnProperty("remove"));

	return !removeCommand
	? [...commands,  { "remove": [] }]
	: commands;
};

const buildRemoveCommands = (commands, dataRowId) => {
	const commandsWithoutRemoveCommand = commands.filter(command => !command.hasOwnProperty("remove"));
	const { remove: removeCommandsId } = commands.find(command => command.hasOwnProperty("remove"));

	return [
		...commandsWithoutRemoveCommand,
		{ remove: [...removeCommandsId, dataRowId] }
	]
};
